import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useMergeRefs } from '@floating-ui/react';
import { useStyles } from '../../../hooks/useStyles';
import { FloatingTransition } from '../../../components/FloatingTransition';
import { NavigationDrawerContent } from '../../../components/NavigationDrawerContent';
import { Drawer } from '../../../components/Drawer';
import { useAppLayoutContext } from '../AppLayout.context';
import { appLayoutNavigationDrawerSideSheetContentStyles, appLayoutNavigationDrawerStyles, } from './AppLayoutNavigationDrawer.styles';
export const AppLayoutNavigationDrawer = forwardRef(function AppLayoutNavigationDrawer(props, forwardedRef) {
    const { styles, sx, detached, ...other } = props;
    const appLayoutContext = useAppLayoutContext();
    const { combineStyles, globalStyles } = useStyles({
        name: 'AppLayoutNavigationDrawer',
        styles: [appLayoutNavigationDrawerStyles, styles],
    });
    const transitionNodeRef = useRef(null);
    const transitionNodeHandleRef = useMergeRefs([
        transitionNodeRef,
        forwardedRef,
    ]);
    const hasNavigationDrawer = appLayoutContext.components.includes('navigationDrawer');
    if (!hasNavigationDrawer) {
        return null;
    }
    const standardNavigationDrawerOpened = appLayoutContext.navigationDrawer?.state?.standardOpened;
    const modalNavigationDrawerOpened = appLayoutContext.navigationDrawer?.state?.modalOpened;
    const anchor = 'left';
    const renderContent = (props) => (_jsx(NavigationDrawerContent, { anchor: anchor, innerStyles: {
            sideSheetContent: appLayoutNavigationDrawerSideSheetContentStyles,
        }, ...other, ...props, sx: [
            globalStyles,
            combineStyles('navigationDrawerContent'),
            props?.sx,
            sx,
        ] }));
    return (_jsxs(_Fragment, { children: [_jsx(Drawer, { root: appLayoutContext.root, opened: modalNavigationDrawerOpened, onClose: appLayoutContext.navigationDrawer?.state?.close, anchor: anchor, detached: detached, sx: combineStyles('host'), children: ({ close }) => renderContent({
                    showCloseButton: true,
                    onClose: close,
                    variant: detached ? 'detachedModal' : 'modal',
                    sx: combineStyles('inner$modal'),
                    ref: forwardedRef,
                }) }), _jsx(CSSTransition, { nodeRef: transitionNodeRef, in: standardNavigationDrawerOpened, timeout: 150, unmountOnExit: true, children: (status) => (_jsx(FloatingTransition, { status: status, placement: anchor, origin: 'edge', pattern: 'enterExitOffScreen', sx: combineStyles('transitionContainer'), ref: transitionNodeHandleRef, children: renderContent({
                        onClose: appLayoutContext.navigationDrawer?.state?.close,
                        variant: 'standard',
                        ref: transitionNodeHandleRef,
                    }) })) })] }));
});
